const initialState = {
  callback: null,
  callbackArgs: null,
  callbackType: null,
  email: '',
  errorMsg: '',
  errorSignUpMsg: '',
  languageMenuOpened: false,
  languageSelected: I18n.locale,
  mobileUserSubmenuOpened: false,
  modalOpened: false,
  password: '',
  repeatPassword: '',
  subscribeToEmails: true,
  userMenuOpened: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EMAIL':
      return Object.assign({}, state, { email: action.email.trim() });
    case 'SET_SIGNIN_ERROR':
      return Object.assign({}, state, { errorMsg: action.errorMsg });
    case 'SET_SIGNUP_ERROR':
      return Object.assign({}, state, { errorSignUpMsg: action.errorSignUpMsg });
    case 'SET_SELECTED_LANGUAGE':
      return Object.assign({}, state, { languageSelected: action.lang });
    case 'CLOSE_LANGUAGE_MENU':
      return Object.assign({}, state, { languageMenuOpened: false });
    case 'TOGGLE_LANGUAGE_MENU':
      return Object.assign({}, state, { languageMenuOpened: !state.languageMenuOpened });
    case 'CLOSE_USER_MENU':
      return Object.assign({}, state, { userMenuOpened: false });
    case 'TOGGLE_USER_MENU':
      return Object.assign({}, state, { userMenuOpened: !state.userMenuOpened });
    case 'TOGGLE_MOBILE_USER_SUBMENU':
      return Object.assign({}, state, { mobileUserSubmenuOpened: !state.mobileUserSubmenuOpened });
    case 'OPEN_MODAL':
      return Object.assign({}, state, { modalOpened: true });
    case 'OPEN_MODAL_WITH_CALLBACK':
      return Object.assign({}, state, {
        modalOpened: true,
        callback: action.callback,
        callbackType: action.callbackType,
        callbackArgs: action.callbackArgs
      });
    case 'CLOSE_MODAL':
      return Object.assign({}, state, {
        modalOpened: false, password: '', repeatPassword: '', callback: null, callbackType: null, callbackArgs: null
      });
    case 'SET_PASSWORD':
      return Object.assign({}, state, { errorMsg: '', password: action.password.trim() });
    case 'SET_REPEAT_PASSWORD':
      return Object.assign({}, state, { errorMsg: '', repeatPassword: action.repeatPassword.trim() });
    case 'TOGGLE_SUBSCRIBE_TO_EMAILS':
      return Object.assign({}, state, { subscribeToEmails: !state.subscribeToEmails });
    default:
      return state;
  }
};

export { initialState, reducer };
export default reducer;
